import { render, staticRenderFns } from "./PlayerInfo.vue?vue&type=template&id=6b10d17a&scoped=true"
import script from "./PlayerInfo.vue?vue&type=script&lang=ts"
export * from "./PlayerInfo.vue?vue&type=script&lang=ts"
import style0 from "./PlayerInfo.vue?vue&type=style&index=0&id=6b10d17a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b10d17a",
  null
  
)

export default component.exports